import React from 'react'
// import styles from './index.module.sass'

interface Props {
  items: any[],
  active: number
}

export const Steps: React.FC<Props> = ({items, active}) => {
  // const fiveSteps = () => (
  //   <div className={styles.steps}> 
  //     <div className={`${styles.step}`}>
  //       {active + 1}
  //     </div>
  //   </div> 
  // )
  
  switch(items.length) {
    // case 5: 
    //   return fiveSteps()

    // case 2:
    //   return fiveSteps()

    default:
      return null
  }
}
